var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingGray4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 1.5H1.25V36.5H36.25V1.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5488 21.0312C27.5488 21.9981 27.3555 22.965 27.0654 23.8351C25.9052 27.3158 22.6179 29.8296 18.7505 29.8296C14.8831 29.8296 11.5958 27.3158 10.4356 23.8351C10.1455 22.965 9.95215 21.9981 9.95215 21.0312H27.5488Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5.6693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.466 13.5843C13.8543 13.5843 14.9798 12.4588 14.9798 11.0705C14.9798 9.68211 13.8543 8.55664 12.466 8.55664C11.0776 8.55664 9.95215 9.68211 9.95215 11.0705C9.95215 12.4588 11.0776 13.5843 12.466 13.5843Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0343 13.5843C26.4227 13.5843 27.5481 12.4588 27.5481 11.0705C27.5481 9.68211 26.4227 8.55664 25.0343 8.55664C23.646 8.55664 22.5205 9.68211 22.5205 11.0705C22.5205 12.4588 23.646 13.5843 25.0343 13.5843Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingGray4);
export default __webpack_public_path__ + "static/media/rating-gray-4.d87f229b73fed1885a1cc299d7868b46.svg";
export { ForwardRef as ReactComponent };